export const ReservationType = {
  Fixed: "fixed",
  CancelByUser: "cancel_by_user",
  CancelByUserRideTimeout: "cancel_by_user_ride_timeout",
};

export type ReservationType = typeof ReservationType[keyof typeof ReservationType];

export interface SystemAlerts {
  userId: number;

  reservationType: string;

  historyCreatedAt: number;
}



// WEBPACK FOOTER //
// ./src/providers/servicer/models/system-alerts.ts